import {IAccessTokenResponse, ICenterRoles} from '@evencel/models';

export class ShowLoading {
    public static readonly type = '[App] ShowLoading';
    constructor(public loading: boolean) {}
}

export class HandleTokenResponse {
    public static readonly type = '[App] HandleTokenResponse';
    constructor(public response: IAccessTokenResponse) {}
}

export class UpdateCenterRoles {
    public static readonly type = '[App] UpdateCenterRoles';
    constructor(public centerRoles: ICenterRoles) {}
}

export class DarkMode {
    public static readonly type = '[App] DarkMode';
}

export class UpdateDirtyFormIndex {
    public static readonly type = '[App] UpdateDirtyFormIndex';
    constructor(public index: number) {}
}

/**
 * Action trigger when need to save the current durty form
 */
export class SaveOpenForm {
    public static readonly type = '[App] SaveOpenForm';
    constructor(public action: true | false | undefined) {}
}

/**
 * Action trigger when save is completed without an issue
 */
export class SavedOpenFormCompleted {
    public static readonly type = '[App] SavedOpenFormCompleted';
    // constructor(public action: true | false | undefined) {}
}
